import { TableRow } from "@mui/material";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import { AllDeviceConnectionTableRowProps } from "../../../constants/types";
import styled from "styled-components";
import { COLORS } from "../../../constants/colors";

const StyledTableRow = styled(TableRow)<any>(() => ({
  [`&`]: {
    background: COLORS.lightGray3,
  },
  [`&:nth-of-type(even)`]: {
    padding: "0.65%",
    fontSize: "1em",
    fontWeight: 600,
    color: COLORS.fontColor,
    background: "white",
  },
}));

const AllDeviceConnectionTableRow = (
  props: AllDeviceConnectionTableRowProps
) => {
  return (
    <StyledTableRow>
      <PublicStyledTableCell>{props.name}</PublicStyledTableCell>
      <PublicStyledTableCell>
        {props.connected + " / " + props.total}
      </PublicStyledTableCell>
    </StyledTableRow>
  );
};

export default AllDeviceConnectionTableRow;
